import { useContext, useState } from 'react';
import StandardizedDataTable from '../../PrimeAids/StandardizedDataTable';
import { ReportContext } from '../../../context/ReportContext';
import { dataRollUp } from '../../PlotlyAids/dataRollUps';
import { formatDateToIsoExtDate, userColumns } from '../../../helpers';
import ReportLineChart from '../../PlotlyAids/ReportLineChart';
import ReportChartLayoutWrapper from '../../PlotlyAids/ReportChartLayoutWrapper';
import ExpandableInfoCard, {
    ExpandableInfoCardDescription,
    ExpandableInfoCardDetail,
} from '../../Cards/ExpandableInfoCard';

const UserMoneyMindfulness = () => {
    const { reportData } = useContext(ReportContext);

    const columns = [
        ...userColumns,
        { field: 'programDatetime', name: 'Program Date ({tz} time zone)', dataType: 'datetime' },
        { field: 'programWeek', name: 'Week', dataType: 'multiselect' },
        { field: 'programDay', name: 'Day', dataType: 'multiselect' },
        { field: 'isProgramDayComplete', name: 'Complete', dataType: 'boolean' },
    ];

    const [filteredData, setFilteredData] = useState([]);

    // const rolledUp = dataRollUp(
    //     filteredData,
    //     (row) => formatDateToIsoExtDate(row.programDate),
    //     {
    //         count: true,
    //     }
    // );

    // const chartData = [
    //     {
    //         name: 'Total Money Mindfulness Updates',
    //         x: rolledUp.map((x) => x.groupByField),
    //         y: rolledUp.map((x) => x.count),
    //     },
    // ];

    return (
        <div className="space-y-6">
            <StandardizedDataTable
                data={reportData}
                columns={columns}
                onValueChange={setFilteredData}
            />
            {/* <ReportChartLayoutWrapper>
                <ReportLineChart
                    data={chartData}
                    chartTitle="User Money Mindfulness Over Time"
                />
            </ReportChartLayoutWrapper> */}

            <ExpandableInfoCard title="What is this data?">
                <ExpandableInfoCardDescription>
                    This report shows user progress through the Money Mindfulness Program-
                    a daily check-in program for guiding users through various articles,
                    meditations, and journaling exercises. Each row represents a user's
                    activity on a specific day of the program.
                </ExpandableInfoCardDescription>
                <ExpandableInfoCardDetail name="Program Date">
                    The date when the user accessed or completed program content.
                </ExpandableInfoCardDetail>
                <ExpandableInfoCardDetail name="Week">
                    Which week of the Money Mindfulness program the activity corresponds
                    to.
                </ExpandableInfoCardDetail>
                <ExpandableInfoCardDetail name="Day">
                    Which day within the program week this activity represents.
                </ExpandableInfoCardDetail>
                <ExpandableInfoCardDetail name="Complete">
                    Whether the user completed all required activities for that program
                    day.
                </ExpandableInfoCardDetail>
            </ExpandableInfoCard>
        </div>
    );
};

export default UserMoneyMindfulness;
